<template lang="pug">
.supercharged-entertainment-container
  .page-buy-play-card.book-race
    .book-form
      form(@submit.prevent="addToCartAndGo")
        agree-to-terms.book-form__agreement(v-model="termsAgreed")
        re-group-box.book-form__tab.playcard-amount(:class="{ disabled: !termsAreAgreed }")
          template(slot="title") Select your amount &amp; quantity
          span.book-form__tab__number 1
          p.info-note Select an Amount &amp; Purchase {{PLAYCARD_TC}}.
          p(v-if="playcardProduct && playcardProduct.fee_fixed > 0") {{ newCardFeeSentence }}
          .selector.flex-rows
            .flex-grow.p-r-15.playcard-product
              label Amount
              select(v-model="playcardProductId" @input="$v.playcardProductId.$reset")
                option(v-for="{ id, title } in playcardProducts" :value="id") {{ title }}
            .flex-grow.p-l-15.playcard-quantity
              label Quantity
              input.book-form__input-full(v-model="playcardQuantity" type="number" min="1" step="1" @input="$v.playcardQuantity.$reset")

        re-content-placeholder(name="purchase_card_below_product_selection")
        bonus-box.m-t-30(v-if="playcardProduct && playcardQuantity" :bonus="playcardProduct.balance.bonus_cash * playcardQuantity")

        include ../../components/global/parts/views/personal-details.pug

        would-you-like-to.m-t-30(v-if="!editMode" exclude="supercharged.buy-play-card" @before-route="likeClick")

        .book-form__add-to-cart
          v-button.site_button.site_button_inverse(:disabled="isAnyInvalid" :loading="isAddingToCart")
            span {{ editMode ? 'Update Cart' : 'Add to Cart' }}
</template>

<script>
import ConfigMixin from '../../components/_mixins/config'
import PagesMixin from '../../components/_mixins/pages'
import PersonalDetailsMixins from '../../components/_mixins/personal-details'
import LocationMixin from 'utils/vue/mixins/location'
import AgreeToTerms from '../../components/parts/AgreeToTerms'
import BonusBox from '../../components/parts/BonusBox'
import WouldYouLikeTo from '../../components/parts/would-you-like-to'
import {getQS} from '../../lib/utils'
const qs = getQS() || {}
const EventBus = window.VueEventBus

const mixins = [
  ConfigMixin,
  PagesMixin,
  PersonalDetailsMixins,
  LocationMixin
]

try {
  mixins.push(require('marketing/playcards/_mixins/buy-playcard-form').default)
} catch (e) {}

export default {
  name: 'page-buy-play-card',
  settings: 'page.buy-playcard',
  translations: 'page.buy-playcard',
  components: {
    AgreeToTerms,
    BonusBox,
    WouldYouLikeTo,
  },

  mixins,

  data: () => ({
    termsAgreed: 'no',

    firstName: null,
    lastName: null,
    phone: null,
    email: null
  }),
  watch: {
    playcardProductId(newVal) {
      EventBus.$emit('buy-card.change.productId', newVal)
      EventBus.$emit('buy-card.change.product', this.playcardProduct)
      EventBus.$emit('buy-card.change.product-with-location', {
        product: this.playcardProduct,
        location_id: this.currentLocationId
      })
    }
  },
  created() {
    if (qs.item || this.$route.query.item) {
      this.setEditItem(qs.item || this.$route.query.item)
    }

    if (!this.editMode) {
      this.playcardQuantity = 1
      const productId = this.$route.query.product
      if (this.playcardProducts.find(x => x.id == productId)) {
        this.playcardProductId = productId
      }
    } else {
      this.termsAgreed = 'yes'
      this.$nextTick(function () {
        this.firstName = _.get(this.editItem, 'payload.options.contact.first_name')
        this.lastName = _.get(this.editItem, 'payload.options.contact.last_name')
        this.phoneConfirmation = this.phone = _.get(this.editItem, 'payload.options.contact.phone')
        this.emailConfirmation = this.email = _.get(this.editItem, 'payload.options.contact.email')
      })
    }

    this.$v.$touch()
  },

  computed: {
    termsAreAgreed() {
      return this.termsAgreed == 'yes'
    },
    disabledPersonalDetails() {
      return !this.termsAreAgreed
    },
    isAnyInvalid() {
      return !this.termsAreAgreed || this.addingToCartDisabled || this.$v.personalDetails.$invalid
    },
    newCardFeeSentence() {
      return this.$$t(
        'newCardFeeSentence',
        'A new card fee of {fee} will be taken from the balance of each card purchased.',
        { fee: '$' + Number(this.playcardProduct.fee_fixed).toFixed(2) }
      )
    }
  },

  methods: {
    async addToCartAndGo() {
      await this.addToCart()
      this.$router.push({ name: 'racewaybooking.checkout' })
    },

    async addToCart() {
      const item = this.getPlaycardCartItem()
      const contact = {
        first_name: this.firstName,
        last_name: this.lastName,
        phone: this.phone,
        email: this.email,
      }
      _.set(item, 'payload.options.contact', contact)
      if (this.currentLocationId) {
        _.set(item, 'payload.options.location_id', this.currentLocationId)
      }
      await this.addPlaycardCartItem(item)
    },

    likeClick() {
      if (this.termsAreAgreed && !this.addingToCartDisabled) {
        this.addToCart()
      }
    },
  }
}
</script>

<style lang="scss">
@import '../../components/_scss/base';

.supercharged-entertainment-container .page-buy-play-card {
  .radio-container {
    margin-bottom: unset;
  }

  .book-form {
    padding-bottom: 85px;
  }

  @media screen and (max-width: 770px) {
    .book-form__tab.playcard-amount .selector {
      flex-direction: column;
      .flex-grow {
        padding: 0;
      }
      .playcard-product {
        margin-bottom: 15px;
      }
    }
    .book-form__tab__radio label {
      padding-bottom: 24px;
    }
  }
}
</style>
